const previousExperience = [
  {
    name: "Not required",
    value: "NOT_REQUIRED",
  },
  {
    name: "1-3",
    value: "ONE_TO_THREE",
  },
  {
    name: "3+",
    value: "THREE_PLUS",
  },
];

export default previousExperience;
